import { styled } from '@abyss/web/tools/styled';
import React, { FC, PropsWithChildren } from 'react';

const StyledHeaderBar = styled('header', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
  borderBottom: '1px solid $gray4',
  position: 'fixed',
  background: 'white',
  zIndex: 200,
  margin: 0,
  padding: 0,
});

export const HeaderBar: FC<PropsWithChildren> = ({ children }) => {
  return (
    <StyledHeaderBar>
      <div id="mainHeader" data-testid="main-header" data-cy="main-header">
        <div id="headerContent">{children}</div>
      </div>
    </StyledHeaderBar>
  );
};
